import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import { AuthContext } from '../../../context/AuthContext'
import api from "../../../services/api";
import {IEventStage} from "../../../interfaces/IEventStage";
import ResultsPrinting from "../EventResult/ResultsPrinting";
import { IEvent } from "../../../interfaces/IEvent";

export default function EventStageList() {
    const { authUser } = useContext(AuthContext)
    const [eventStages, setEventStages] = useState<IEventStage[]>([])
    const [event, setEvent] = useState<IEvent | null>(null)
    const [printingEntryId, setPrintingEntryId] = useState<number | null>(null)
    const navigate = useNavigate();
    const {id} = useParams();

  useEffect(() => {
        api.get('/api/events/' + id).then(res => setEvent(res.data))
        api.get('/api/event_stages/event/' + id).then(resposta => setEventStages(resposta.data))
    }, [])


    return (
        <>
            {/*Testes E2E com Playwright*/}
            <div className="row">
                <div className="col-md-12">
                    <h3 className="mb-2">
                        <b>Etapas</b>
                    </h3>
                    <h5 className="mb-2">
                        <b>{event?.competition?.title} - {event?.title}</b>
                    </h5>
                </div>
            </div>
            <div className="row my-4">
                {eventStages.map(stage =>
                    <div key={stage.id} className="col-md-4 mt-3">
                        <div className="card">
                            {(['admin'].includes(authUser?.role)) && (
                                <Link
                                    to={`/event-stages/edit/${stage.id}`}
                                    className="btn btn-warning btn-sm position-absolute end-0 m-1"
                                >
                                    <i className="bi bi-pencil"></i>
                                </Link>
                            )}
                            {stage.image && (
                                <img className={stage.status === 'finished' ? 'card-img-top img-blur' : 'card-img-top'} src={!stage.image?"/logo192.png": stage.image} style={{maxHeight:'240px'}} alt="Logo prova" />
                            )}
                            <div className="card-body">
                                <h4 className="card-title">{stage.title}</h4>
                                <p className="card-text">{stage.description}</p>

                                <div className="row">
                                  {stage.status !== 'finished' &&
                                    <div className="col-sm-6 my-1">
                                      <Link to={!stage.event_entry_id ? `/event-dates/${stage.id}` : `/event-results/${stage.event_entry_id}`} className="btn btn-primary w-100"><i className="bi bi-clipboard-data">&nbsp;</i> Acessar</Link>
                                    </div>
                                  }
                                  {(stage.status === 'finished' || stage.show_result) && stage.event_entry_id &&
                                    <div className="col-sm-6 my-1">
                                      <button className="btn btn-success w-100" onClick={() => setPrintingEntryId(stage.event_entry_id)}>
                                        <i className="bi bi-trophy-fill">&nbsp;</i>Resultados
                                      </button>
                                    </div>
                                  }
                                </div>

                            </div>
                        </div>
                    </div>
                )}

            </div>

            <div className="row">
                 <div className="col-md-12 text-right" >
                   <button className="btn btn-danger btn-floating" onClick={() => navigate(-1)} >Voltar<br /></button> </div>
            </div>

            {printingEntryId && (
                <ResultsPrinting
                    key={printingEntryId}
                    eventEntryId={printingEntryId}
                    childToParent={() => setPrintingEntryId(null)}
                />
            )}
        </>
    );
}
